import { render, staticRenderFns } from "./HeaderTragos.vue?vue&type=template&id=26eef963&scoped=true&"
import script from "./HeaderTragos.vue?vue&type=script&lang=js&"
export * from "./HeaderTragos.vue?vue&type=script&lang=js&"
import style0 from "./HeaderTragos.vue?vue&type=style&index=0&id=26eef963&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26eef963",
  null
  
)

export default component.exports